export async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('Service Worker registered:', registration);
      
      // Request background sync permission
      if ('sync' in registration) {
        console.log('Background sync available');
      }
      
      // Listen for online/offline events
      window.addEventListener('online', async () => {
        console.log('Online - triggering sync');
        if ('sync' in registration) {
          await registration.sync.register('sync-attendance');
        }
      });
      
      return registration;
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  }
}

export async function getQueuedAttendanceCount() {
  if ('caches' in window) {
    const cache = await caches.open('offline-attendance-queue');
    const requests = await cache.keys();
    return requests.length;
  }
  return 0;
}